
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M20.166 9.166v2.75q0 5.5-5.5 5.5h-.458a.929.929 0 00-.733.367L12.1 19.616a1.3 1.3 0 01-2.2 0l-1.375-1.833a1.036 1.036 0 00-.733-.367h-.459c-3.667 0-5.5-.917-5.5-5.5V7.333q0-5.5 5.5-5.5h5.5","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M20.166 4.125a2.292 2.292 0 11-2.291-2.292 2.292 2.292 0 012.291 2.292z","stroke-width":"1.5","opacity":".4"}}),_c('path',{attrs:{"d":"M14.664 10.083h.005M10.996 10.083h.005M7.329 10.083h.005","stroke-width":"2","opacity":".4"}})])])
          )
        }
      }
    